import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ZoneInfoCard = ({ zone, onClose }) => {
  if (!zone) return null;

  const getStatusColor = (status) => {
    switch (status) {
      case 'protected': return 'text-success';
      case 'moderate': return 'text-warning';
      case 'critical': return 'text-error';
      default: return 'text-muted-foreground';
    }
  };

  return (
    <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 w-[32rem] max-w-full bg-card rounded-lg shadow-conservation-lg z-[400] animation-organic">
      <div className="p-6 space-y-4">
        <div className="flex items-start justify-between gap-4">
          <div className="flex-1">
            <h3 className="text-xl font-semibold text-foreground mb-2">{zone?.name}</h3>
            <div className="flex items-center gap-2">
              <span className={`text-sm font-medium ${getStatusColor(zone?.status)}`}>
                {zone?.status?.charAt(0)?.toUpperCase() + zone?.status?.slice(1)} Zone
              </span>
              <span className="text-sm text-muted-foreground">• {zone?.area} hectares</span>
            </div>
          </div>
          <button
            onClick={onClose}
            className="flex-shrink-0 hover:bg-muted/50 p-2 rounded-lg transition-colors"
            aria-label="Close zone info"
          >
            <Icon name="X" size={20} color="var(--color-foreground)" />
          </button>
        </div>
        
        <p className="text-sm text-foreground leading-relaxed">{zone?.description}</p>
        
        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-1">
            <div className="flex items-center gap-2 text-muted-foreground text-xs">
              <Icon name="Users" size={14} />
              <span>Biodiversity Index</span>
            </div>
            <div className="text-lg font-semibold text-foreground">{zone?.biodiversityIndex}</div>
          </div>
          
          <div className="space-y-1">
            <div className="flex items-center gap-2 text-muted-foreground text-xs">
              <Icon name="TrendingUp" size={14} />
              <span>Threat Level</span>
            </div>
            <div className="text-lg font-semibold text-foreground">{zone?.threatLevel}/10</div>
          </div>
          
          <div className="space-y-1">
            <div className="flex items-center gap-2 text-muted-foreground text-xs">
              <Icon name="Eye" size={14} />
              <span>Active Monitoring</span>
            </div>
            <div className="text-lg font-semibold text-foreground">{zone?.activeMonitoring}</div>
          </div>
          
          <div className="space-y-1">
            <div className="flex items-center gap-2 text-muted-foreground text-xs">
              <Icon name="Shield" size={14} />
              <span>Ranger Patrols</span>
            </div>
            <div className="text-lg font-semibold text-foreground">{zone?.rangerPatrols}/day</div>
          </div>
        </div>
        
        <div className="flex gap-2 pt-2">
          <Button variant="default" iconName="FileText" className="flex-1">
            View Reports
          </Button>
          <Button variant="outline" iconName="Download" className="flex-1">
            Export Data
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ZoneInfoCard;